import React, { Component } from "react";
import { connect } from "react-redux";
import moment from "moment";
import Papa from "papaparse";

import withStyles from "@material-ui/styles/withStyles";
import Paper from "@material-ui/core/Paper";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import Divider from "@material-ui/core/Divider";

import ActionCancel from "@material-ui/icons/Cancel";

import {
  PageHeader,
  PageFooter,
  SaveButton,
  Button,
  SimpleForm,
  FileInput,
  FileField,
  required,
  RestMethods
} from "jazasoft";
import { dataProvider } from "../../App";
import CardHeader from "../../components/CardHeader";

const FormFooter = ({ saving, onCancel, ...props }) => {
  // console.log({saving});
  return (
    <PageFooter>
      <SaveButton label="Submit" saving={saving} {...props} />
      <Button label="Cancel" variant="contained" onClick={onCancel}>
        <ActionCancel />
      </Button>
    </PageFooter>
  );
};

const styles = theme => ({
  constainer: {
    margin: theme.spacing(3)
  },
  padding: {
    padding: theme.spacing(3)
  }
});

class ExecuteLogs extends Component {
  state = {
    executing: false,
    messages: []
  };
  onSubmit = values => {
    this.executeLogs(values.file.rawFile);
  };

  onCancel = () => {
    this.setState({ executing: false });
  };

  executeLogs = async file => {
    this.setState({ executing: true });

    const { data: rows, errors, meta } = await this.readCsv(file);
    console.log({ rows, errors, meta });

    let messages = [];
    let idMap = {};

    messages.push({ type: "info", message: `Log Execution Started...` });
    this.setState({ messages });

    for (let i = 0; i < rows.length; i++) {
      const row = rows[i];
      if (row["Time"] === "") continue;

      if (!row["Api"] || row["Api"].trim().length === 0) {
        messages.push({
          type: "error",
          message: `[Step ${i + 1}][${moment().format(
            "hh:mm:ss a"
          )}]: This step cannot be executed. API field is missing. row = ${JSON.stringify(row)}`
        });
        this.setState({ messages });
        continue;
        // break;
      }
      if (row["Skip"] && parseInt(row["Skip"]) === 1) {
        messages.push({
          type: "info",
          message: `[Step ${i + 1}][${moment().format("hh:mm:ss a")}]: Execution of Event (${row["Event"]}) Skipped.`
        });
        this.setState({ messages });
        continue;
      }
      if (!this.state.executing) {
        messages.push({ type: "info", message: `Log Execution aborted.` });
        this.setState({ messages });
        break;
      }

      let extraInfoList = [];
      if (row["Styles"]) {
        extraInfoList.push(`Styles - ${row["Styles"]}`);
      }
      if (row["Colors"]) {
        extraInfoList.push(`Colors - ${row["Colors"]}`);
      }
      if (row["Product"]) {
        extraInfoList.push(`Product - ${row["Product"]}`);
      }
      if (row["Part"]) {
        extraInfoList.push(`Part - ${row["Part"]}`);
      }
      if (row["Lot"]) {
        extraInfoList.push(`Lot ${row["Lot"]}`);
      }
      if (row["Dest"]) {
        extraInfoList.push(`Dest ${row["Dest"]}`);
      }
      if (row["Item Code"]) {
        extraInfoList.push(`Item Code - ${row["Item Code"]}`);
      }
      const extraInfo = extraInfoList.join(", ");
      messages.push({
        type: "info",
        message: `[Step ${i + 1}][${moment().format("hh:mm:ss a")}]: Execution of Event (${
          row["Event"]
        }) [${extraInfo}] started ...`
      });
      this.setState({ messages });

      // process url
      let url = row["Api"] && row["Api"].replace("/api/", ""); // Remove '/api' as dataProvider auto includes it
      url = this.sanitizeUrl(url); // Replace '/' with '-'
      let splits = url.split("/");
      splits = splits.map(s => (s.includes("{") ? idMap[s.replace("{", "").replace("}", "")] : s));
      url = splits.join("/");
      //process data
      let data = row["Data"] ? JSON.parse(row["Data"]) : {};
      if (row["Event"] === "Order Created") {
        data = { ...data, customerId: 1, seasonId: 1, productId: 1 };
      }
      if (row["Event"] === "Fabric Created") {
        data = { ...data, millId: 1, fabricTypeId: 1, fabricCategoryId: 1 };
      }
      if (row["Event"] === "Shrinkage Grouping Completed" || row["Event"] === "Final Grouping Completed") {
        data = { ...data, log: true };
      }

      this.assignId(data, idMap);
      //process params
      let params = row["Params"] ? JSON.parse(row["Params"]) : {};
      params = Object.keys(params).reduce(
        (acc, key) => ({
          ...acc,
          [key]:
            typeof params[key] === "string" && params[key].includes("{")
              ? idMap[params[key].replace("{", "").replace("}", "").replace(/\//g, "-")]
              : params[key]
        }),
        {}
      );
      const options = {
        url,
        method: row["Method"],
        params,
        data
      };
      console.log({ row, options, idMap: { ...idMap } });
      try {
        const result = await dataProvider(RestMethods.CUSTOM, undefined, options);

        if (result.data) {
          this.recordId(result.data, idMap);
          this.recordId(result.data.content, idMap);
        }

        messages.push({
          type: "success",
          message: `[Step ${i + 1}][${moment().format("hh:mm:ss a")}]: Execution of Event (${
            row["Event"]
          }) [${extraInfo}] finished.`
        });
        this.setState({ messages });
      } catch (e) {
        let error = e.message || JSON.stringify(e);

        messages.push({
          type: "error",
          message: `[Step ${i + 1}][${moment().format("hh:mm:ss a")}]: Execution of Event (${
            row["Event"]
          }) failed. Error = ${error}`
        });
        this.setState({ messages });

        // Fetch Fabric Id if Fabric is already created.
        if (typeof e.message === "string" && e.message.includes("Duplicate Entry.")) {
          let options;
          if (row["Event"] === "Fabric Created") {
            options = {
              url: `fabrics`,
              method: "GET",
              params: { search: `itemCode=='${row["Item Code"]}'` }
            };
          } else if (row["Event"] === "Fabric Inward") {
            options = { url, method: "GET" };
          }
          if (options) {
            const result = await dataProvider(RestMethods.CUSTOM, undefined, options);
            console.log({ result });
            if (result.data) {
              this.recordId(result.data, idMap);
              this.recordId(result.data.content, idMap);
            }
            console.log({ idMap });
          }
        }
      }
    }

    messages.push({ type: "info", message: `Log Execution Finished.` });
    this.setState({ messages, executing: false });
  };

  recordId = (record, idMap) => {
    if (!record) return;
    if (Array.isArray(record)) {
      record.forEach(e => this.recordId(e, idMap));
    } else if (typeof record === "object") {
      if (record.uid && record.id) {
        idMap[record.uid.replace(/\//g, "-")] = record.id;
      }
      Object.keys(record).forEach(key => this.recordId(record[key], idMap));
    }
  };

  sanitizeUrl = url => {
    if (!url) return;
    let idx = 0;
    let result = "";

    while (idx !== -1) {
      let openIdx, closeIdx;
      openIdx = url.indexOf("{", idx);
      closeIdx = url.indexOf("}", idx + 1);
      if (openIdx !== -1 && closeIdx !== -1) {
        result += url.substring(idx, openIdx);
        let str = url.substring(openIdx, closeIdx);
        str = str.replace(/\//g, "-");
        result += str;
      } else {
        result += url.substring(idx);
      }
      idx = closeIdx;
    }
    return result;
  };

  assignId = (record, idMap) => {
    if (!record) return;
    if (Array.isArray(record)) {
      record.forEach(e => this.assignId(e, idMap));
    } else if (typeof record === "object") {
      if (record.uid) {
        record.id = idMap[record.uid.replace(/\//g, "-")];
      }
      Object.keys(record).forEach(key => {
        if (typeof record[key] === "string" && record[key].startsWith("{")) {
          record[key] = idMap[record[key].replace("{", "").replace("}", "").replace(/\//g, "-")];
        }
      });
      Object.keys(record).forEach(key => this.assignId(record[key], idMap));
    }
  };

  readCsv = file => {
    return new Promise(resolve => {
      Papa.parse(file, {
        header: true,
        complete: result => {
          resolve(result);
        }
      });
    });
  };

  sleep = millis => {
    return new Promise(resolve => {
      setTimeout(() => {
        resolve();
      }, millis);
    });
  };

  render() {
    const { classes } = this.props;
    const { messages, executing } = this.state;
    return (
      <div>
        <PageHeader title="Execute Logs" />

        <div className={classes.constainer}>
          <Paper className={classes.padding}>
            <SimpleForm
              saving={executing}
              onSubmit={this.onSubmit}
              footer={<FormFooter saving={executing} onCancel={this.onCancel} />}>
              <FileInput
                source="file"
                label="Log File"
                accept="text/csv, application/vnd.ms-excel"
                xs={12}
                fullWidth
                validate={[required()]}>
                <FileField source="src" title="title" />
              </FileInput>
            </SimpleForm>
          </Paper>

          {messages && messages.length > 0 && (
            <div style={{ marginTop: "1.5em" }}>
              <Card>
                <CardHeader title="Message" />
                <Divider />
                <CardContent>
                  <List>
                    {messages.map(({ type, message }, idx) => (
                      <ListItem key={idx} button>
                        <ListItemText
                          style={{
                            color: type === "error" ? "red" : type === "success" ? "green" : undefined
                          }}
                          primary={message}
                        />
                      </ListItem>
                    ))}
                  </List>
                </CardContent>
              </Card>
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default connect()(withStyles(styles)(ExecuteLogs));
